// extracted by mini-css-extract-plugin
export default {"profile-background":"Profile_profile-background__XV1LP","avatar":"Profile_avatar__NzF5E","username":"Profile_username__TGLhQ","error":"Profile_error__VESuI"};